<div class="wn-assistant" [class.wn-assistant--open]="store.isOpen()">
  <button
    type="button"
    class="wn-assistant__toggle"
    [attr.aria-expanded]="store.isOpen()"
    [attr.aria-label]="
      store.isOpen() ? ('LANDING.ASSISTANT.CLOSE_ARIA' | translate) : ('LANDING.ASSISTANT.TOGGLE_ARIA' | translate)
    "
    (click)="toggle()"
  >
    <i class="pi" [class.pi-comments]="!store.isOpen()" [class.pi-times]="store.isOpen()"></i>
  </button>

  @if (store.isOpen()) {
    <div class="wn-assistant__panel glass-panel" role="dialog" [attr.aria-label]="'LANDING.ASSISTANT.TITLE' | translate">
      <header class="wn-assistant__header">
        <strong>{{ 'LANDING.ASSISTANT.TITLE' | translate }}</strong>
        <button type="button" class="wn-assistant__talk-to-sales" (click)="openLeadForm()">
          {{ 'LANDING.ASSISTANT.TALK_TO_SALES' | translate }}
        </button>
      </header>

      <div class="wn-assistant__messages" aria-live="polite">
        @for (message of store.messages(); track $index) {
          <div class="wn-assistant__message" [class.wn-assistant__message--user]="message.role === 'user'">
            {{ message.content }}
          </div>
        }
        @if (store.sending()) {
          <div class="wn-assistant__typing" role="status">
            <i class="pi pi-spin pi-spinner"></i>
          </div>
        }
        @if (store.errorMessage(); as err) {
          <p class="wn-assistant__error">{{ err | translate }}</p>
        }
        @if (showLeadPrompt()) {
          <button type="button" class="wn-assistant__lead-prompt" (click)="openLeadForm()">
            {{ 'LANDING.ASSISTANT.LEAD.PROMPT' | translate }}
          </button>
        }
        @if (showRegistrationPrompt()) {
          <!--
            TODO: point at a real self-serve registration route once one exists —
            CreateTenantPageComponent exists but isn't wired to a route today;
            /login is the closest existing entry point.
          -->
          <a routerLink="/login" class="wn-assistant__lead-prompt">
            {{ 'LANDING.ASSISTANT.SUGGEST_REGISTRATION' | translate }}
          </a>
        }
      </div>

      @if (leadFormOpen()) {
        <form class="wn-assistant__lead-form" (ngSubmit)="submitLead()">
          <input type="text" name="name" [ngModel]="leadName()" (ngModelChange)="leadName.set($event)"
                 [placeholder]="'LANDING.ASSISTANT.LEAD.NAME' | translate" required />
          <input type="email" name="email" [ngModel]="leadEmail()" (ngModelChange)="leadEmail.set($event)"
                 [placeholder]="'LANDING.ASSISTANT.LEAD.EMAIL' | translate" required />
          <input type="text" name="company" [ngModel]="leadCompany()" (ngModelChange)="leadCompany.set($event)"
                 [placeholder]="'LANDING.ASSISTANT.LEAD.COMPANY' | translate" required />
          <input type="tel" name="phone" [ngModel]="leadPhone()" (ngModelChange)="leadPhone.set($event)"
                 [placeholder]="'LANDING.ASSISTANT.LEAD.PHONE' | translate" required />
          <input type="text" name="website" class="wn-assistant__honeypot" tabindex="-1" autocomplete="off"
                 aria-hidden="true" [ngModel]="leadHoneypot()" (ngModelChange)="leadHoneypot.set($event)" />
          @if (leadError(); as err) {
            <p class="wn-assistant__error">{{ err | translate }}</p>
          }
          <button type="submit" [disabled]="leadSubmitting()">
            {{ 'LANDING.ASSISTANT.LEAD.SUBMIT' | translate }}
          </button>
        </form>
      } @else {
        <form class="wn-assistant__input" (ngSubmit)="send()">
          <input type="text" name="draft" [ngModel]="draft()" (ngModelChange)="draft.set($event)"
                 [placeholder]="'LANDING.ASSISTANT.PLACEHOLDER' | translate" />
          <button type="submit" [disabled]="store.sending()">{{ 'LANDING.ASSISTANT.SEND' | translate }}</button>
        </form>
      }
    </div>
  }
</div>
